import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Alert, { alertClasses } from '@mui/material/Alert'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

type Props = {
  open: boolean
  onClose: () => void
  onProceed: () => void
  onReviewDuplicates: () => void
}

export function DuplicatesFoundDialog(props: Props) {
  const { open, onClose, onProceed, onReviewDuplicates } = props
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" sx={{ p: 0 }}>
      <DialogTitle sx={{ p: 3, pb: 2 }}>Duplicates Found</DialogTitle>
      <DialogContent sx={{ p: 3, pt: 0 }}>
        <Alert
          color="warning"
          severity="warning"
          sx={{
            alignItems: 'flex-start',
            backgroundColor: '#FEF8E9',
            [`& .${alertClasses.icon}`]: { color: '#F9BA1B' },
          }}
        >
          <Typography variant="body2" color="#89660F">
            Potential duplicates were found. Are you sure you want to proceed?
          </Typography>
        </Alert>

        <Button
          variant="text"
          size={isMobile ? 'large' : 'medium'}
          onClick={onReviewDuplicates}
          endIcon={<OpenInNewIcon fontSize="small" />}
          sx={{
            color: '#1565C0',
            textTransform: 'none',
            fontWeight: 500,
            minWidth: 'fit-content',
            mt: 1,
          }}
        >
          Review Duplicates
        </Button>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button onClick={onClose} variant="text">
          Close
        </Button>
        <Button onClick={onProceed} variant="contained" color="primary">
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicatesFoundDialog
